import { graphql } from '@/gql';
import type { UnmarkRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const unmarkRide = async ({ rideId, requestId }: UnmarkRideMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      rideId,
      requestId,
    },
    mutation: graphql(`
      mutation UnmarkRide($rideId: String, $requestId: String) {
        unmarkRide(rideId: $rideId, requestId: $requestId) {
          id
        }
      }
    `),
  });

  return response.data?.unmarkRide;
};
